import React from "react";
import { TiiBubble } from "../CoinTiiDisplay/CoinTiiDisplay";
import styles from "./NftScroll.module.scss";
import { Media } from "components/Media/media";
import { reverse } from "lodash";
import classNames from "classnames";

interface Props {}

const NftScroll = (props: Props) => {
  const nftOptions = [
    "TEN",
    "XXI",
    "ONE",
    "RUN",
    "BABE",
    "DAD",
    "MOM",
    "EPIC",
    "FAME",
    "GIRL",
    "GOAL",
    "HACK",
    "HERO",
    "HOOP",
    "WILL",
    "JEN",
    "CARI",
    "MEL",
    "JIM",
    "JUAN",
    "JAZZ",
    "COOL",
    "KING",
    "KID",
    "KISS",
    "META",
    "MEGA",
    "AMZN",
    "RACE",
    "TSLA",
    "RICH",
    "TECH",
    "VIBE",
    "YOGA",
    "GOLF",
    "TEAM",
    "OMG",
    "WOW",
    "SEXY",
    "PINK",
    "RED",
    "BLUE",
    "AZUL",
    "SHIB",
    "HEX",
    "MSU",
    "UCLA",
    "USC",
    "MICH",
    "AURA",
    "CODY",
    "DALE",
    "JADE",
    "JESS",
  ];

  const reversed = reverse([...nftOptions]);

  return (
    <>
      <div className={styles.NftScroll__container}>
        <div className={styles.NftScroll}>
          <div className={styles.NftScroll__stretchContainer}>
            {nftOptions.map((o) => (
              <TiiBubble
                className={styles.NftScroll__tii}
                type="dark"
                size="sm"
                text={o}
                key={`${o}-7`}
              />
            ))}
          </div>
          <div className={styles.NftScroll__stretchContainer}>
            {nftOptions.map((o) => (
              <TiiBubble
                className={styles.NftScroll__tii}
                type="dark"
                size="sm"
                text={o}
                key={`${o}-8`}
              />
            ))}
          </div>
        </div>
        <Media lessThan="md">
          <div className={styles.NftScroll}>
            <div
              className={classNames(
                styles.NftScroll__stretchContainer,
                styles.NftScroll__stretchContainer__reverse
              )}
            >
              {nftOptions.map((o) => (
                <TiiBubble
                  className={styles.NftScroll__tii}
                  type="dark"
                  size="sm"
                  text={o}
                  key={`${o}-7`}
                />
              ))}
            </div>
            <div
              className={classNames(
                styles.NftScroll__stretchContainer,
                styles.NftScroll__stretchContainer__reverse
              )}
            >
              {nftOptions.map((o) => (
                <TiiBubble
                  className={styles.NftScroll__tii}
                  type="dark"
                  size="sm"
                  text={o}
                  key={`${o}-8`}
                />
              ))}
            </div>
          </div>
        </Media>
        <Media lessThan="md">
          <div className={styles.NftScroll}>
            <div
              className={classNames(
                styles.NftScroll__stretchContainer,
                styles.NftScroll__stretchContainer__offset
              )}
            >
              {reversed.map((o) => (
                <TiiBubble
                  className={styles.NftScroll__tii}
                  type="dark"
                  size="sm"
                  text={o}
                  key={`${o}-7`}
                />
              ))}
            </div>
            <div
              className={classNames(
                styles.NftScroll__stretchContainer,
                styles.NftScroll__stretchContainer__offset
              )}
            >
              {reversed.map((o) => (
                <TiiBubble
                  className={styles.NftScroll__tii}
                  type="dark"
                  size="sm"
                  text={o}
                  key={`${o}-8`}
                />
              ))}
            </div>
          </div>
        </Media>
      </div>
    </>
  );
};

export default NftScroll;
